import { useRef, useState } from "react";
import { FaClipboardList, FaEdit } from "react-icons/fa";
import { MdOutlineFileUpload } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import PageHeader from "../../Components/PageHeader";
import { setAuth } from "../../store/reducer/auth";
import { updateUser } from "../../store/reducer/user";
import api from "../../Utils/api";
import { API_URL_FILE, IMG_USER_URL } from "../../Utils/constants";

const Profile = () => {
  const img_url_default = "./dist/";
  const auth = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [update, setUpdate] = useState(false);
  const [profilImg, setprofilImg] = useState(null);
  const [password, setPassword] = useState("");
  const passwordRef = useRef(null);
  const repasswordRef = useRef(null);
  const formatAccepted = ".png,.jpg,.jpeg";

  const handleCheckPassword = (e) => {
    const { value } = e.target;
    if (password !== value) {
      setPassword("");
      passwordRef.current.value = "";
      e.target.value = "";
      toast.error("Les mots de passe ne sont pas identiques.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userData = {
      ...auth,
      roles: auth.roles?.includes("ROLE_ADMIN") ? "ROLE_ADMIN" : "ROLE_MOD",
      lastname: e.target[0].value,
      firstname: e.target[1].value,
      contact: e.target[2].value,
    };
    try {
      const response = await api.put(`users/${userData.id}`, userData);
      if (response.data.user) {
        toast.success("Mise à jour éffectuée.");
        dispatch(updateUser(userData));
        dispatch(setAuth(userData));
        setUpdate((update) => !update);
      } else {
        toast.error("Vérifier vos données avant la soumission.");
      }
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    }
  };

  const handleChangePasswordSubmit = async (e) => {
    e.preventDefault();

    const pw = { password };
    try {
      const { data } = await api.put(`users/${auth.id}`, pw);

      if (!data.user) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }

      setPassword("");
      passwordRef.current.value = "";
      repasswordRef.current.value = "";
      toast.success("Mise à jour éffectuée.");
      setUpdate((update) => !update);
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    }
  };

  const handleFileChange = async (event) => {
    event.preventDefault();

    const selectedFiles = event.target.files;
    if (!selectedFiles && selectedFiles.length <= 0) {
      return;
    }

    const [newFile, error] = formatAcceptedFiles(
      Array.from(selectedFiles),
      formatAccepted
    );

    if (error.length > 0) {
      displayError(error);
      return;
    }

    const file = { img: newFile };

    // console.log(file);
    try {
      const { data } = await api.post(`users/${auth.id}`, file, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (!data.user) {
        toast.error("Vérifier vos données avant la soumission.");
        return;
      }

      const tmp = {
        ...auth,
        img: data.user.img,
      };

      dispatch(setAuth(tmp));
      dispatch(updateUser(tmp));

      toast.success("Mise à jour éffectuée.");
      setUpdate((update) => !update);
    } catch (error) {
      if (error.response.status === 401) {
        navigate("/login");
      }
    }
    setprofilImg(newFile[0]);
  };

  const formatAcceptedFiles = (files, format) => {
    const deniedFormat = [];
    const result = [];

    for (const file of files) {
      const fileParts = file.name.split(".");
      const extension = fileParts[fileParts.length - 1];
      // console.log((file.size / (1024 * 1000)).toFixed(2) > 1);

      if (file.size / (1024 * 2000) > 1) {
        deniedFormat.push("size");
        continue;
      }

      if (!format.includes(extension)) {
        if (!deniedFormat.includes(extension)) {
          deniedFormat.push(extension);
        }
        continue;
      }

      result.push(file);
    }

    return [result, deniedFormat];
  };

  const displayError = (error) => {
    if (error.includes("size")) {
      toast.error(`Taille fichier doit être < 1 Mo.`);
    }

    if (error.length > 1) {
      toast.error(`Extension de fichiers acceptés : ${formatAccepted}`);
    }
  };

  const handleCheckContact = (e) => {
    const { value } = e.target;
    if (value.length <= 0) return;
    // const regex = /^\+\d{1,2}\s?\d{10}$/;
    // console.log(value.length);
    if (value.length < 10) {
      e.target.value = "";
      toast.warning("Le contact doit contenir au moins 10 chiffres.");
    }
  };

  return (
    <>
      <PageHeader page="Profile" />

      {/* Modal */}
      <>
        <div
          className="modal fade"
          id="changePassword"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-hidden="true"
          data-backdrop="static"
          data-keyboard="false"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  Changer le mot de passe
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <form
                className="form-horizontal"
                onSubmit={handleChangePasswordSubmit}
              >
                <div className="modal-body">
                  <div className="form-group row">
                    <label
                      htmlFor="password"
                      className="col-sm-5 col-form-label"
                    >
                      Nouveau mot de passe
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        name="password"
                        onChange={(e) => setPassword(e.target.value)}
                        ref={passwordRef}
                        placeholder="Nouveau mot de passe"
                      />
                    </div>
                  </div>
                  <div className="form-group row">
                    <label
                      htmlFor="repassword"
                      className="col-sm-5 col-form-label"
                    >
                      Confirmer mot de passe
                    </label>
                    <div className="col-sm-7">
                      <input
                        type="password"
                        className="form-control"
                        id="repassword"
                        name="repassword"
                        onBlur={handleCheckPassword}
                        ref={repasswordRef}
                        placeholder="Confirmer mot de passe"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-secondary"
                    data-dismiss="modal"
                  >
                    Annuler
                  </button>
                  <button type="submit" className="btn btn-primary">
                    Valider
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
      {/* Modal */}

      {/* Main content */}
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3">
              {/* Profile Image */}
              <div
                className="card card-primary card-outline"
                style={{ height: "25.6rem" }}
              >
                <div
                  className="card-body box-profile"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    paddingTop: "4rem",
                  }}
                >
                  <div className="text-center mb-3 hover-div" style={{}}>
                    {update && (
                      <div
                        className="hidden-div"
                        data-toggle="tooltip"
                        data-placement="top"
                        title="Changer mon image de profil"
                      >
                        <label htmlFor="profilImg">
                          <MdOutlineFileUpload />
                        </label>
                        <input
                          type="file"
                          id="profilImg"
                          name="profilImg"
                          onChange={handleFileChange}
                          accept={formatAccepted}
                        />
                      </div>
                    )}

                    {!profilImg ? (
                      <img
                        className="profile-auth-img img-fluid img-circle"
                        style={{ height: "220px" }}
                        src={
                          auth?.img &&
                          ((auth?.img.split("/")).length > 1
                            ? img_url_default
                            : API_URL_FILE + "/" + IMG_USER_URL) + auth?.img
                        }
                        height={220}
                        width={220}
                        alt="CurrenUser profile"
                      />
                    ) : (
                      <img
                        className="profile-auth-img img-fluid img-circle"
                        src={URL.createObjectURL(profilImg)}
                        alt="CurrenUser profile"
                        height={220}
                        width={220}
                      />
                    )}
                  </div>
                  <h3 className="profile-currenUsername text-center">
                    {auth &&
                      auth.firstname?.split(" ")[0].charAt(0).toUpperCase() +
                        auth.firstname?.split(" ")[0].slice(1) +
                        " "}
                    {auth.lastname?.toUpperCase()}
                  </h3>
                  <p className="text-muted text-center">
                    {auth && auth.roles?.includes("ROLE_ADMIN")
                      ? "Administrateur"
                      : "Utilisateur"}
                  </p>
                  {/* <ul className="list-group list-group-unbordered mb-3">
                    <li className="list-group-item">
                      <b>Followers</b> <a className="float-right">1,322</a>
                    </li>
                    <li className="list-group-item">
                      <b>Following</b> <a className="float-right">543</a>
                    </li>
                    <li className="list-group-item">
                      <b>Friends</b> <a className="float-right">13,287</a>
                    </li>
                  </ul>
                  <a href="#" className="btn btn-primary btn-block">
                    <b>Follow</b>
                  </a> */}
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
              {/* /.card */}
            </div>
            {/* /.col */}
            <div className="col-md-9">
              <div className="card">
                <div className="card-header p-2">
                  {update && (
                    <button
                      type="button"
                      className="btn btn-primary ml-2 mt-1"
                      data-toggle="modal"
                      data-target="#changePassword"
                    >
                      Changer mot de passe
                    </button>
                  )}

                  <div
                    className="card-tools"
                    style={{
                      marginBottom: "-2%",
                    }}
                  >
                    <p
                      className="mr-4"
                      data-toggle="tooltip"
                      data-placement="top"
                      title="Mise à jour"
                      style={{
                        // color: "#ccc",
                        cursor: "pointer",
                        fontSize: "1.4rem",
                        color: "#1d75f0",
                      }}
                      onClick={() => setUpdate(!update)}
                    >
                      {update ? <FaClipboardList /> : <FaEdit />}
                    </p>
                  </div>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="tab-content">
                    <div className="active tab-pane" id="activity">
                      {/* Post */}
                      {auth && (
                        <form
                          className="form-horizontal"
                          onSubmit={handleSubmit}
                        >
                          <div className="form-group row">
                            <label
                              htmlFor="lastname"
                              className="col-sm-2 col-form-label"
                            >
                              Nom
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="lastname"
                                placeholder="Nom"
                                disabled={!update}
                                defaultValue={auth.lastname}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="firstname"
                              className="col-sm-2 col-form-label"
                            >
                              Prénom
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="firstname"
                                placeholder="Prénom"
                                disabled={!update}
                                defaultValue={auth.firstname}
                              />
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="firstname"
                              className="col-sm-2 col-form-label"
                            >
                              Contact
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="contact"
                                placeholder="Contact"
                                disabled={!update}
                                onBlur={handleCheckContact}
                                defaultValue={auth.contact ? auth.contact : ""}
                              />
                            </div>
                          </div>
                          {!update && (
                            <>
                              <div className="form-group row">
                                <label
                                  htmlFor="inputEmail"
                                  className="col-sm-2 col-form-label"
                                >
                                  Username
                                </label>
                                <div className="col-sm-10">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="inputEmail"
                                    placeholder="Email"
                                    defaultValue={auth.username}
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor="role"
                                  className="col-sm-2 col-form-label"
                                >
                                  Rôle
                                </label>
                                <div className="col-sm-10">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="role"
                                    defaultValue={
                                      auth.roles?.includes("ROLE_ADMIN")
                                        ? "Administrateur"
                                        : "Modérateur"
                                    }
                                    disabled
                                  />
                                </div>
                              </div>
                              <div className="form-group row">
                                <label
                                  htmlFor="actif"
                                  className="col-sm-2 col-form-label"
                                >
                                  Status
                                </label>
                                <div className="col-sm-10">
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="actif"
                                    defaultValue={
                                      auth.isActif ? "Activé" : "Désactivé"
                                    }
                                    disabled
                                  />
                                </div>
                              </div>
                            </>
                          )}
                          {update && (
                            <>
                              <div className="form-group row">
                                <div className="offset-sm-2 col-sm-10">
                                  <button
                                    type="submit"
                                    className="btn btn-info"
                                  >
                                    Metre à jour
                                  </button>
                                </div>
                              </div>
                            </>
                          )}
                        </form>
                      )}
                    </div>
                    {/* /.tab-pane */}
                  </div>
                  {/* /.tab-content */}
                </div>
                {/* /.card-body */}
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
      {/* /.content */}
    </>
  );
};

export default Profile;
